export const ReviewParameterKeys = {
  WorkloadId: 'WorkloadId',
  ReportId: 'ReportId',
};
